<template>
  <div class="grid">
    <div class="content--wrapper">
      <h1>Completa los parámetros</h1>

      <p class="info" v-if="category === WhatsappTemplateCategories.OTP">
        La plantilla de autenticación siempre vendrá con el siguiente contenido: “Tu código de
        verificacion es {{ paramString(1) }}”. Además, contará con un botón para copiar en el
        portapapeles el código que se ingrese al enviar la plantilla.
      </p>

      <CustomScrollbar style="margin-top: 16px" height="430px" auto>
        <a-form layout="vertical" class="form" ref="formRef" :model="formState">
          <a-form-item
            v-for="idx in number"
            :key="idx"
            :label="'Nombre del parámetro {{' + idx + '}}'"
            required
          >
            <a-input v-model:value="formState[idx]" placeholder="Ingrese el nombre" />
          </a-form-item>
        </a-form>
      </CustomScrollbar>
    </div>

    <WhatsappTemplatePhone
      style="place-self: center"
      :content="content"
      :templateType="templateType"
      :templateCategory="category"
      :templateButton="templateButton"
    />
  </div>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, watch, inject } from "vue";

import { templateCategoriesOptions } from "@/app/channels/utils/selectOptions";
import { WhatsappTemplateCategories } from "@/app/channels/utils/enums";

import WhatsappTemplatePhone from "@/app/shared/components/organisms/WhatsappTemplatePhone.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const paramString = (num = "") => `{{${num}}}`;

export default defineComponent({
  components: {
    WhatsappTemplatePhone,
    CustomScrollbar,
  },
  props: {
    number: Number,
    content: String,
    category: String,
  },
  setup(props, { emit, expose }) {
    const formRef = ref(null);

    const templateType = inject("templateType");
    const templateButton = inject("templateButton");
    const formState = reactive({});
    const valid = ref(false);
    watch(
      () => props.category,
      (newCategory) => {
        if (newCategory !== WhatsappTemplateCategories.OTP) return;

        formState[1] = "Código de verificación";
      },
      { immediate: true }
    );

    const validateFormState = ({ validateEmpty = true }) => {
      if (validateEmpty && !formState?.[props.number] && formState?.[props.number] !== '') return;

      if (!validateEmpty && !formState?.[props.number]) {
        valid.value = false;
        return emit("inactive-button")
      }

      // Limpiar valores de formState mayores a la cantidad de parametros
      let formEntries = Object.entries(formState);
      if (props.number < formEntries.length && !validateEmpty) {
        formEntries.splice(props.number, formEntries.length - 1);
        const newFormState = Object.fromEntries(formEntries);
        Object.keys(formState).forEach(key => {
          if (!(key in newFormState)) {
            delete formState[key];
          }
        });
      }

      for (const key in formState) {
        if (!formState[key]) {
          valid.value = false;
          return emit("inactive-button")
        };
      }
      valid.value = true;
      return emit("active-button");
    }

    watch(formState, () => 
      {
        validateFormState({ validateEmpty: true });
      }, { immediate: true, deep: true }
    );

    expose({ formState: { parameters: toRaw(formState) } , valid, validateFormState });

    return {
      WhatsappTemplateCategories,
      paramString,
      templateCategoriesOptions,
      formRef,
      formState,
      templateType,
      templateButton,
    };
  },
});
</script>

<style lang="sass" scoped>
.grid
  display: grid
  grid-template-columns: 1.1fr 0.9fr
  gap: 25px
  height: 100%

h3
  font-size: 16px
  font-weight: 600

h1
  margin-bottom: 0

p
  color: $gray-8

.content
  min-height: 254px
  max-height: 254px

  &--wrapper
    padding-top: 8px

.info
  color: $text-primary
  margin: 0
  margin-top: 4px
  line-height: 22px
</style>
